import React, { useEffect } from 'react'
import PartList from './PartList'
import Header from './Header'
import CancelBtn from '../components/CancelBtn'
import ImagesGallery from '../components/ImagesGallery'
import View from './View'
import { Lightbox } from 'react-modal-image'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { AppState } from '../reducers'
import { AppMode } from '../constants'
import Footer from './Footer';
import WelcomeMessage from '../components/WelcomeMessage'

type AppProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const App = ({ loading, modalSrc, msg, modalClose, bgColor, newOrderApplication, productsToShow, filters, isFiltering, isImagesLoading, loadImages, appMode, sliderImgsPath, isSliderOn }: AppProps) => {
	const isViewLoading = () => isFiltering || isImagesLoading;

	useEffect(() => {
		// Jeżeli wszystkie filtry wybrane, to ładujemy obrazki
		if (Object.keys(filters).filter(key => filters[key] === null).length === 0 && !isFiltering) {
			loadImages();
		} 
	}, [filters, isFiltering, loadImages]);

	if (loading) {
		return (
			<div id="kr-app">
				<div id="kr-loader">
					<div className="kr-spinner"></div>
					<p>Trwa ładowanie aplikacji...</p>
					{msg === "" ? null : <p>{msg}</p>}
				</div>
			</div>
		)
	}
	return (
		<div id="kr-app">
			{modalSrc === null ? null : (
				<Lightbox
					medium={modalSrc}
					hideDownload={true}
					hideZoom={true}
					onClose={modalClose}
				/>
			)}
			{!newOrderApplication ? <CancelBtn /> : null}
			<Header />
			{
				Object.keys(filters).filter(key => filters[key] === null).length === 0 && !isViewLoading() ? 
				<div id="kr-content">
					{appMode === AppMode.Order ? <h3>Wpisz zamawianą ilość poszczególnych produktów</h3> : ''}
					<div className="kr-flex">
						<PartList />
						<View />
					</div>
				</div>
				:
				<div id="kr-content-not-ready">
						{isViewLoading() ? (
							<div id='kr-slider-container-spinner'>
								<div className="kr-spinner"></div>	
							</div>
						) : (
							 isSliderOn ?
								<ImagesGallery /> :
								<WelcomeMessage />
						)}
				</div>
			}
			{msg === "" ? null : <p>{msg}</p>}
			<Footer />
		</div>
	)
}

const mapStateToProps = (state: AppState) => {
	return {
		loading: state.loading,
		modalSrc: state.modalSrc,
		msg: state.msg,
		bgColor: state.filteredAssortment.products[0]?.bgColor ?? '',
		newOrderApplication: state.config?.newOrderApplication as boolean,
		productsToShow: state.filteredAssortment.products,
		filters: state.filters,
		isFiltering: state.isFiltering,
		isImagesLoading: state.imagesLoading,
		appMode: state.loading ? '' : state.config.appMode,
		sliderImgsPath: state.config?.sliderImgsPath,
		isSliderOn: state.config?.isSliderOn
	}
}

const mapDispatchToProps = dispatch => ({
	modalClose: () => {
		dispatch(actions.modal(null))
	},
	loadImages: () => {
		dispatch(actions.loadImagesForViewProducts())
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
